import {Component, forwardRef, Inject, OnInit} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {User} from '../../core/domain/user';
import {HomeComponent} from '../home.component';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { ProfileStoreService } from 'app/profile/service/profile-store.service';
import { Profile } from 'app/profile/domain/profile';
import { ProfileService } from 'app/profile/service/profile.service';

@Component({
    selector: 'app-inline-profile',
    templateUrl: './inline-profile.component.html',
    styleUrls: ['./inline-profile.component.scss'],
    animations: [
        trigger('menu', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class InlineProfileComponent implements OnInit {

    active: boolean;

    userIn: User = new User();
    profilePhoto = '';

    constructor(@Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
    private authService: AuthService, private profileStoreService: ProfileStoreService) {
}

    ngOnInit(): void {
    this.authService.user
    .subscribe(user => {
        this.userIn = user
        this.profileStoreService.getProfile().subscribe( p => {
            this.profilePhoto = p.profilePhoto;
        } )
    });

    }

    onClick(event) {
        this.active = !this.active;
        event.preventDefault();
    }

    public logout() {
        this.authService.logout();
    }

    public activeChange() {
        this.active = !this.active;
    }


}



// WEBPACK FOOTER //
// ./src/app/home/inline-profile/inline-profile.component.ts